import { useTranslation } from "react-i18next";
import {
  isValidDiskSize,
  isGreaterThanZero,
  requiredRule,
  checkDiskSizeIncrease,
} from "./useBasicComponent";

import { useInstanceTypeComponent } from "./useInstanceTypeComponent";

export const machineTypeEnum = {
  "m5.2xlarge": { text: "m5.2xlarge" },
  "m5.4xlarge": { text: "m5.4xlarge" },
  "m5.8xlarge": { text: "m5.8xlarge" },
  "m5.16xlarge": { text: "m5.16xlarge" },
};

export const useNodegroupConfig = (
  enableDruid,
  action = "create",
  defaultValues = {},
  prefix = "",
  context = "instance"
) => {
  const { t } = useTranslation();
  const { instanceTypeComponent } = useInstanceTypeComponent();
  const disableFlag = action === "create" ? false : true;
  // const disableFlag = true;
  const groupItems = (group) => {
    let items = [
      {
        title: t("config.instance.form.desiredSize", "Desired Size"),
        dataIndex: `${prefix}${group}.desiredSize`,
        valueType: "digit",
        width: "sm",
        colProps: { xs: 24, sm: 8 },
        formItemProps: {
          rules: [
            ...requiredRule(t),
            // {
            //   validator(_, value) {
            //     if (isGreaterThanZero(value)) {
            //       return Promise.resolve();
            //     }
            //     return Promise.reject(
            //       new Error(
            //         t(
            //           "config.instance.error.desiredSize",
            //           "The desired Size must be greater than zero.",
            //         ),
            //       ),
            //     );
            //   },
            // },
          ],
        },
      },
      {
        title: t("config.instance.form.minSize", "Min Size"),
        dataIndex: `${prefix}${group}.minSize`,
        valueType: "digit",
        width: "sm",
        colProps: { xs: 24, sm: 8 },
        formItemProps: {
          rules: [
            ...requiredRule(t),
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  !value ||
                  value < getFieldValue(`${prefix}${group}.maxSize`)
                ) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t(
                      "config.instance.error.minSize",
                      "The minSize must be less than the maxSize.",
                    ),
                  ),
                );
              },
            }),
          ],
        },
      },
      {
        title: t("config.instance.form.maxSize", "Max Size"),
        dataIndex: `${prefix}${group}.maxSize`,
        valueType: "digit",
        width: "sm",
        colProps: { xs: 24, sm: 8 },
        formItemProps: {
          rules: [
            ...requiredRule(t),
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value > getFieldValue(`${prefix}${group}.minSize`)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t(
                      "config.instance.error.maxSize",
                      "The maxSize should be greater than minSize.",
                    ),
                  ),
                );
              },
            }),
          ],
        },
      },
      instanceTypeComponent(group),
    ];

    items.push({
      title: t("config.instance.form.disk", "Disk"),
      dataIndex: `${prefix}${group}.disk`,
      fieldProps: {
        disabled: disableFlag,
      },
      formItemProps: {
        rules: [
          ...requiredRule(t),
          {
            validator(_, value) {
              if (!isValidDiskSize(value)) {
                return Promise.reject(
                  new Error(
                    t(
                      "config.instance.error.disk",
                      "The format is a positive integer followed by Gi or Mi, for example: 100Gi, 2000Mi",
                    ),
                  ),
                );
              }
              if (action === "update") {
                const defaultValue = defaultValues[`${prefix}${group}.disk`];
                if (!checkDiskSizeIncrease(defaultValue, value)) {
                  return Promise.reject(
                    new Error(
                      t("config.instance.error.diskSize", { defaultValue }),
                    ),
                  );
                }
              }
              return Promise.resolve();
            },
          },
        ],
      },
      width: "sm",
      colProps: { xs: 24, sm: 8 },
    });

    return items;
  };

  const nodegroupSchema = [
    {
      i18nTitle: "config.instance.form.master",
      title: t("config.instance.form.master", "Master"),
      valueType: "group",
      columns: groupItems("master"),
    },
    {
      i18nTitle: "config.instance.form.worker",
      title: t("config.instance.form.worker", "Worker"),
      valueType: "group",
      columns: groupItems("worker"),
    },
    {
      i18nTitle: "config.instance.form.database",
      title: t("config.instance.form.database", "Database"),
      valueType: "group",
      columns: groupItems("database"),
    }
  ];
  if(enableDruid) {
    nodegroupSchema.push({
      i18nTitle: "config.instance.form.druid.master",
      title: t("config.instance.form.druid.master", "Druid-Master"),
      valueType: "group",
      columns: groupItems("druid-master"),
    })

    nodegroupSchema.push({
      i18nTitle: "config.instance.form.druid.worker",
      title: t("config.instance.form.druid.workder", "Druid-Worker"),
      valueType: "group",
      columns: groupItems("druid-worker"),
    })
  }

  return nodegroupSchema;
};
